// Access control for the EMEA ECM Tracker.
// The allowlist lives in the backend (EMEA_ECM_TRACKER_ALLOWED_EMAILS in .env);
// this helper simply asks the server whether the current user is permitted, so
// the front-end can decide whether to show the navbar entry and open the route.
const apiUrl = process.env.REACT_APP_API_URL;

const authHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("access_token");
  return { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
};

export async function fetchEmeaEcmTrackerAccess(): Promise<boolean> {
  if (!apiUrl) return false;
  try {
    const res = await fetch(`${apiUrl}/api/emea-ecm-tracker/access/`, { headers: authHeaders() });
    if (!res.ok) return false;
    const data = await res.json();
    return Boolean(data?.has_access);
  } catch {
    return false;
  }
}
